const { version }: { version: string } = require('../../package.json');

export const environment = {
  production: false,
  // baseUrl: 'https://api-sodimac-pgs.buffetcloud.io/',
  baseUrl: 'https://api-install-qa.sodimac-it.com/api/',
  baseUrl2: 'https://apibeta.cloud.sodimac-it.com/sodimac/api/',
  keycloakUrl: 'https://qa-access-key-corp.falabella.tech/auth/',
  keyckoakRealm: 'corp',
  appVersion: version,
  googleApiKey: '',
  authGenerateToken: 'pgs-authentication/authentication/generate',
  authRefreshToken: 'pgs-authentication/authentication/refresh-token',
  location_locations: 'pgs-vendor-front/localization/country/', // 2 | (Concatenaciones)
  vendors_vendor: 'pgs-vendor-front/vendor', // 1 | 1 Eliminado | (Concatenaciones)
  vendors_contacTypes: 'pgs-vendor-front/contactType', // 1 | (Concatenaciones)
  vendors_updateVendor: 'pgs-vendor-front/vendor', // 1 | 1 Elimiando | (Concatenaciones)
  vendors_persons: 'pgs-vendor-front/vendor/partialSearch', // 1 | 1 Eliminada | (Concatenaciones)
  vendorsPayment_documentTypes: 'pgs-tributarydoc-front/documentType', // 1
  vendorsPayment_vendorDocument: 'pgs-tributarydoc-front/tributaryDocument', // 5 | 2 Eliminadas | (Concatenaciones)
  vendorsPayment_annulmentCauses: 'pgs-tributarydoc-front/reason', // 1 | 1 Eliminado
  vendorsPayment_order: 'pgs-order-front/order', // 1 | 1 Eliminado | (Concatenaciones)
  vendorsPayment_transferTypes: 'pgs-tributarydoc-front/transferType', // 1
  vendorsPayment_submitTransfer: 'pgs-tributarydoc-front/soclapse/generateSoclapse', // 1
  vendorsPayment_addOrder: 'pgs-tributarydoc-front/addOrderToDocument', // 1 | (Concatenación)
  vendorsPayment_removeOrder: 'pgs-tributarydoc-front/removeOrderToDocument', // 1 | (Concatenación)
  vendorsPayment_addDocument: 'pgs-tributarydoc-front/tributaryDocument/addAssociatedDocument', // 1 | (Concatenación)
  vendorsPayment_removeDocument: 'pgs-tributarydoc-front/tributaryDocument/removeAssociatedDocument', // 1 | (Concatenación)
  vendorsPayment_toleranceAmount: 'pgs-tributarydoc-front/tributaryDocument/adjustmentToleranceAmount', // 1 | (Concatenación)
  vendorsPayment_massiveConciliation: 'pgs-tributarydoc-front/tributaryDocument/generateMassiveConciliation', // 1
  vendorsPayment_transferConciliated: 'pgs-tributarydoc-front/soclapse/generateSoclapseConciliatedTransfer', // 1
  vendorsPayment_addTaxDistribution: 'pgs-tributarydoc-front/costCenter/addTaxDistribution', // 1
  reports_order_order_report: 'pgs-order-front/order/getForOrderReport', // 1
  reports_order_by_email: 'pgs-order-front/order/getConsultByOrder', // 1
  reports_retireTypes: 'pgs-vendor-front/getRetireTypes', // 1
  reports_retirementWarrantyFund: 'pgs-vendor-front/retirementWarrantyFund', // 1
  reports_auxiliaryWarranty: 'pgs-vendor-front/warrantyFundAuxiliar', // 1
  reports_auxiliaryWarrantyByEmail: 'pgs-vendor-front/warrantyFundAuxiliar/report', // 1
  vendorsPayment_documentStatus_documentStatus: 'pgs-tributarydoc-front/beenSent/getAllStatus', // 1
  vendorsPayment_documentStatus_guid: 'pgs-tributarydoc-front/beenSent/guid', // 1 | (Concatenación)
  vendorsPayment_documentStatus_documentInterfaces: 'pgs-tributarydoc-front/beenSent/getAllInterface', // 1
  vendorsPayment_documentStatus_documents: 'pgs-tributarydoc-front/soclapse/beenSent', // 1 | 1 Eliminado
  vendorsPayment_documentStatus_documents_LC: 'pgs-tributarydoc-front/soclapse/beenSentLCDetail', // 2
  vendorsPayment_documentStatus_documents_LP: 'pgs-tributarydoc-front/soclapse/beenSentLPDetail', // 2
  vendorsPayment_documentStatus_documents_CR: 'pgs-tributarydoc-front/soclapse/beenSentCRDetail', // 1
  vendorsPayment_errorsCorrection_actionType: 'pgs-tributarydoc-front/actionType', // 1
  vendorsPayment_errorsCorrection_correctionError: 'pgs-tributarydoc-front/soclapse/correctionErrorGet', // 1 | 1 Eliminado
  vendorsPayment_errorsCorrection_correctionAction: 'pgs-tributarydoc-front/soclapse/correctionErrorAction', // 1
  vendorsPayment_sendCR: 'pgs-tributarydoc-front/sap/oc', // 1
  vendorsPayment_loadDocuments: 'pgs-tributarydoc-front/tributaryDocument/insertMassiveBill', // 1
  reports_documentReceptionReport: 'pgs-tributarydoc-front/tributaryDocument/documentReceptionReport', // 1
  reports_documentReceptionByEmail: 'pgs-tributarydoc-front/tributaryDocument/documentReceptionLarge', // 1
  reports_massiveDocumentsStatus_dateTypes: 'pgs-tributarydoc-front/dateTypes', // 1
  reports_massiveDocumentsStatus_documentsStatus: 'pgs-tributarydoc-front/statusTypes', // 1
  reports_massiveDocumentsStatus: 'pgs-tributarydoc-front/massiveExtraction', // 1
  reports_massiveDocumentsByEmail: 'pgs-tributarydoc-front/massiveExtractionAsync', // 1
  reports_postpayCreditNote: 'pgs-tributarydoc-front/tributaryDocument/creditNoteReport', // 1
  set_user: 'pgs-utils-public-front/user', // 2 | (bifurcación)
  get_user: 'pgs-utils-public-front/user/getUser/', // 1 | (bifurcación)
  proyect_payment_proyect: 'pgs-order-front/leadOrder/', // 1 | (Concatenaciones)
  sales_client_clientTypes: 'pgs-customer-front/customerType', // 1
  sales_client_client: 'pgs-customer-front/customer', // 2 | 1 Eliminada | (Concatenaciones)
  sales_service_manager_questions: 'pgs-services-manager-front/servicesManager/getNodeQuestions', // 1 | (Concatenaciones)
  sales_service_manager_feasibility: 'pgs-services-manager-front/servicesManager/coverage', // 1
  sales_service_manager_serviceNodeList: 'pgs-services-manager-front/servicesManager/ServiceNodeLevelList/', // 1 | 2 Eliminadas | (Concatenaciones)
  sales_service_manager_getServicesListByTenant: 'pgs-services-manager-front/servicesManager/getServicesListByTenant', // 1
  sales_service_manager_serviceNode: 'pgs-services-manager-front/servicesManager', // 1 | (Concatenaciones)
  sales_project: 'pgs-order-front/parentOrder', // 5 | Concatenaciones
  sales_project_add_sku: 'pgs-order-front/parentOrder/childOrder/addSkuToChildOrder', // 1
  sales_project_remove_sku: 'pgs-order-front/parentOrder/childOrder/removeSkuToChildOrder', // 1
  sales_project_add_service: 'pgs-order-front/parentOrder/childOrder/create', // 1
  sales_project_remove_service: 'pgs-order-front/childOrder', // 1 | (Concatenaciones)
  sales_contract_generate_contract_pdf_html: 'pgs-services-manager-front/service/generateContractPdfHTML', // 1 | (bifurcación)
  sales_contract_send_mail_contract_pdf: 'pgs-services-manager-front/service/sendMailContractPdf', // 1 | (bifurcación)
  sales_contract_generate_contract_pdf: 'pgs-services-manager-front/service/generateContractPdf', // 1 | (bifurcación)
  sales_contract_generate_contract_pdf_code_64: 'pgs-services-manager-front/service/generateContractPdfCoded64', // 1 | (bifurcación)
  sales_contract_finish: 'pgs-services-manager-front/service/finishContracts', // 1 | (bifurcación)
  sales_fsa: 'pgs-services-manager-front/fsa', // 1
  projects_search_by_id_for_sale: 'pgs-order-front/leadParent/{leadParentId}/sale',
  projects_search_by_customer: 'pgs-order-front/projectOrder/', // 2 | (Concatenaciones)
  projects_search_by_id: 'pgs-order-front/projectDetailedOrder/', // 2 | (Concatenaciones)
  projects_search_by_leadid: 'pgs-order-front/projectDetailedOrderChild/', // 2 | (Concatenaciones)
  projects_tracking: 'pgs-order-front/parentOrder/trackingPanel', // 1
  projects_tracking_status: 'pgs-order-front/projectStatus/all', // 1 | (Concatenaciones)
  projects_binnacle: 'pgs-order-front/binnacle', // 2 | 1 Eliminada
  products_search_name: 'pgs-order-front/product/searchName', // 1 | (Bifurcación)
  products_search_sku: 'pgs-order-front/product/searchSku', // 1 | (Bifurcación)
  users_roles: 'pgs-utils-public-front/role/getAllRoles', // 1
  user_mail_search: 'pgs-utils-public-front/user/getUserForModification', // 1 | (Concatenaciones)
  stores_stores: 'pgs-utils-public-front/user/getStore/', // 1 | (Concatenaciones)
  stores_brand: 'pgs-services-manager-front/brand/', // 1 | (Concatenaciones)
  products_home_delivery: 'pgs-order-front/dadIntegration/deliveryService', // 2
  products_store_delivery: 'pgs-order-front/dadIntegration/storeWithdrawal', // 1
  products_create_reservation: 'pgs-order-front/dadIntegration/reservationCreate/', // 1 | (Concatenaciones)
  products_cancel_reservation: 'pgs-order-front/dadIntegration/reservationCancel/', // 1 | (Concatenaciones)
  projects_sale_order: 'pgs-order-front/saleOrder', // 1 | (Concatenaciones)
  reactive_projects: 'pgs-order-front/parentOrder/reactive', // 1
  order_health: 'pgs-order-front/health', // 1 | 1 Eliminado
  order_version: 'pgs-order-front/info', // 1
  service_manager_health: 'pgs-services-manager-front/health', // 1
  service_manager_version: 'pgs-services-manager-front/info', // 1
  product_health: 'pgs-product-front/health', // 1
  product_version: 'pgs-product-front/info', // 1 | 1 Eliminado
  customer_health: 'pgs-customer-front/health', // 1 | 1 Eliminado
  customer_version: 'pgs-customer-front/info', // 1 | 1 Eliminado
  utils_public_health: 'pgs-utils-public-front/health', // 1 | 1 Eliminado
  utils_public_version: 'pgs-utils-public-front/info', // 1 | 1 Eliminado
  utils_private_health: 'pgs-utils-front/health', // 0 | 1 Eliminado
  tributarydoc_health: 'pgs-tributarydoc-front/health', // 1 | 1 Eliminado
  tributarydoc_version: 'pgs-tributarydoc-front/info', // 1 | 1 Eliminado
  vendor_health: 'pgs-vendor-front/health', // 1 | 1 Eliminado
  vendor_version: 'pgs-vendor-front/info', // 1 | 1 Eliminado
  insert_orders: 'pgs-order-front/order/ssee/migrateOrders', // 1
  master_data: 'pgs-services-manager-front/Category/updateFromExternal/', // 1 | (Concatenaciones)
  get_retention: 'pgs-tributarydoc-front/retention/getAllRetention', // 2
  retention: 'pgs-tributarydoc-front/retention', // 1 | 1 Eliminado - Duplicidad
  channel_services: 'pgs-channel-front/service/generic/sku', // 2 | 2 Eliminadas | (Concatenaciones)
  channel_error_all: 'pgs-channel-front/channel/error/all', // 2 | (Concatenaciones)
  channel_error: 'pgs-channel-front/channel/error', // 1
  channel_straggler: 'pgs-channel-front/channel/straggler', // 1 | (Concatenaciones)
  channel_validate_sku_service: 'pgs-channel-front/servicegenericsku/hermes',
  massive_load_export: 'pgs-vendor-front/massiveLoad/export', // 1
  massive_load_import: 'pgs-vendor-front/vendor/importMasiveLoad', // 1 | (Concatenaciones)
  search_lead_by_filter: 'pgs-order-front/search/leadOrdersByFilter', // 0 | 1 Eliminada
  excelLeadOrdersByFilter: 'pgs-order-front/export/excelLeadOrdersByFilter', // 0 | 1 Eliminada
  checkoutManualPayment: 'pgs-order-front/manualPayment',
  customerBucError: 'pgs-customer-front/customer/error/suscription', // 1
  sodtrackProyUrl: 'https://admin.cl.sodimac.sodtrack.com/es/dashboard/project/',
  findAllServicesUpdate: '/findAllExecutions',
  configExecutionLoadConfig: 'bff-auto-configuration-process/v1.0/configExecution/processFileConfig',
  configExecutionStopExecution: 'bff-auto-configuration-process/v1.0/configExecution/updateProcessExecution',
  configExecutionLoadFlow: 'bff-auto-configuration-process/v1.0/configExecution/loadflow',
  configExecutionPriorities: 'bff-auto-configuration-process/v1.0/configExecution/priorities',
  configExecutionFindAllExecutions: 'bff-auto-configuration-process/v1.0/configExecution/findAllExecutions',
  configExecutionDownloadFile: 'bff-auto-configuration-process/v1.0/configExecution/file',
};



export const authConfig: any = {
  logoutTimeoutMinutes: 30,
  authority: 'https://login.microsoftonline.com/common',
  redirectUri: window.location.origin,
  clientId: '531e7d9d-3e69-4dd0-8c66-30a265fd19b5',
  scope: 'openid profile email https://buffet-guests-list.azurewebsites.net/read',
  buffetUrl: 'https://buffet-guests-list.azurewebsites.net/api/gateway-jwt',
  buffetCode: 'cLyTq96aAj6DvpPbFWhsCqlP/GgAQZhzoNE0YD1Rw70Bx2Ma5P3CRg==',
  postLogoutRedirectUri: window.location.origin + '/',
  logoutUrl: 'https://login.microsoftonline.com/c4a8886b-f140-478b-ac47-249555c30afd/oauth2/logout',
};
